import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { companyEntityToModel } from 'serviceWorker/repository/company/mapping';
import { getUsersSynchronized } from 'serviceWorker/services/users/getUsers';
import * as dbCompanies from '../../db/companies/companies';
import * as dbCompaniesService from '../../db/companies/companiesService';
import { CompanyModel } from 'shared/domain/company/types/model';
import { companyContract } from 'shared/domain/company/companyContract';
import { makeLoadedEventPublisher, readCollectionPayload } from 'serviceWorker/broadcasts/publishers';

/** Every company of IndexedDB as a model; read once the companies are downloaded. */
async function readCompanyModels(): Promise<CompanyModel[]> {
  const [companies, users] = await Promise.all([dbCompanies.get(), getUsersSynchronized()]);
  return companies.map((entity) => companyEntityToModel(entity, users));
}

export const broadcastAllCompanies = makeLoadedEventPublisher(
  companyContract,
  DomainMessagesTypes.allCompanies,
  () => readCollectionPayload(dbCompaniesService, readCompanyModels)
);
